<template>
  <div class="">
    <VirtualTransfer data-value="id" data-label="name" :basedata="basedata" v-model="result" />

  </div>
</template>

<script>
import PVirtualTransfer from "@/components/virtualTransfer";
export default {
  components: {
    "VirtualTransfer": PVirtualTransfer,
  },
  props: ['data', 'checkedData'],
  data() {
    return {
      basedata: [],
      result: [],
      checked: false
    };
  },
  mounted() {
    this.getData();
    this.result = this.checkedData
  },
  watch: {
    result() {
      this.$emit('sendTransferData', this.result)
    },

  },
  methods: {
    getData() {
      this.basedata = this.data.map(i => ({
        name: i.label,
        id: i.key,
        visiable: !!i.visiable
      }))
      console.log(this.basedata);

    },
  },
};
</script>

<style scoped></style>
